// extracted by mini-css-extract-plugin
module.exports = {"table":"WorkspaceActivationList_table_2f46T"};